import { Component, OnInit } from '@angular/core';
import { ILocalizationRecord } from './shared/models/localization-record.model';
import { TranslationLoaderFacade } from './translation-loader.facade';

@Component({
  selector: 'app-localization',
  templateUrl: './localization.component.html',
  styleUrls: ['./localization.component.scss']
})
export class LocalizationComponent implements OnInit {

  constructor(private translationLoaderFacade:TranslationLoaderFacade) { }

  ngOnInit() {
    this.translationLoaderFacade.fetchTranslations();
  }


  getMockData(): ILocalizationRecord[] {
    return [
      // {application: 'Admin Portal', key: '_test1_', defaultText: 'test1',
      //   translations: {en: 'test1en', fr: 'test1fr', es: 'test1es'}
      // },
      // {application: 'Admin Portal', key: '_test2_', defaultText: 'test2',
      //   translations: {en: 'test2en', fr: 'test2fr', es: 'test2es'}
      // },
      // {application: 'Kiosk', key: '_test1_', defaultText: 'test1',
      //   translations: {en: 'test1en', fr: 'test1fr', es: 'test1es'}
      // },
      // {application: 'Kiosk', key: '_test2_', defaultText: 'test2',
      //   translations: {en: 'test2en', fr : 'test2fr', es: 'test2es'}
      // },
    ];
  }
}
